import { Button, CircularProgress, Stack, Typography } from "@mui/material";

const TEAL = "#008080";

interface PollingViewProps {
  firstName?: string;
}

export function PollingView({ firstName }: PollingViewProps) {
  return (
    <Stack spacing={3} alignItems="center" textAlign="center" py={6} px={2}>
      <CircularProgress size={48} sx={{ color: TEAL }} />
      <Typography variant="h5" fontWeight={700} color="#212121">
        {firstName ? `Thanks ${firstName}, we're finding your match…` : "We're finding your match…"}
      </Typography>
      <Typography variant="body1" color="#616161" maxWidth={480}>
        This usually takes just a moment. Please keep this page open while we review your criteria
        against our provider network.
      </Typography>
    </Stack>
  );
}

interface ResultErrorViewProps {
  message: string;
  onRefineSearch: () => void;
}

export function ResultErrorView({ message, onRefineSearch }: ResultErrorViewProps) {
  return (
    <Stack spacing={3} alignItems="center" textAlign="center" py={6} px={2} maxWidth={560} mx="auto">
      <Typography variant="h5" fontWeight={700} color="#212121">
        We couldn't finish matching just yet
      </Typography>
      <Typography variant="body1" color="#616161">
        {message}
      </Typography>
      <Typography variant="body2" color="#616161">
        If you need help, email{" "}
        <a href="mailto:clientconnections@unyte.com" style={{ color: TEAL, fontWeight: 600 }}>
          clientconnections@unyte.com
        </a>
      </Typography>
      <Button
        variant="contained"
        onClick={onRefineSearch}
        disableElevation
        sx={{
          bgcolor: TEAL,
          textTransform: "none",
          fontWeight: 600,
          flexDirection: "row",
          "&:hover": { bgcolor: "#006666" },
        }}
      >
        Refine My Search
      </Button>
    </Stack>
  );
}

interface TerminalStatusViewProps {
  status: string;
  onRefineSearch: () => void;
}

export function TerminalStatusView({ status, onRefineSearch }: TerminalStatusViewProps) {
  return (
    <Stack spacing={3} alignItems="center" textAlign="center" py={6} px={2} maxWidth={560} mx="auto">
      <Typography variant="h5" fontWeight={700} color="#212121">
        We've received your request
      </Typography>
      <Typography variant="body1" color="#616161">
        Your submission status is "{status}". If you have questions or need to update your criteria,
        please email us or refine your search below.
      </Typography>
      <Typography
        component="a"
        href="mailto:clientconnections@unyte.com"
        variant="body1"
        fontWeight={700}
        sx={{ color: TEAL, textDecoration: "none" }}
      >
        clientconnections@unyte.com
      </Typography>
      <Button
        variant="outlined"
        onClick={onRefineSearch}
        sx={{
          borderColor: TEAL,
          color: TEAL,
          textTransform: "none",
          fontWeight: 600,
          flexDirection: "row",
        }}
      >
        Refine My Search
      </Button>
    </Stack>
  );
}
